










































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import store from 'src/assets/store'
import ItemDataLive from 'src/assets/ItemDataLive'
import { AttendeeItemData, Slide, SlideParamsValues, Response, AttendeeResponseResult } from 'src/assets/AttendeeItemData'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import ButtonClose from 'components/attendee/session/ButtonClose.vue'
import ButtonNext from 'components/attendee/session/ButtonNext.vue'
import SlidesViewer from 'components/presenter/item/topic/viewer/SlidesViewer.vue'
import api from 'src/assets/api/gql'
import AttendeeUpdateResponse from 'src/graphql/attendee/AttendeeUpdateResponse.gql'
import AttendeeUpdateResponseAndSessionStats from 'src/graphql/attendee/AttendeeUpdateResponseAndSessionStats.gql'
import AttendeeUpdateResponseMeta from 'src/graphql/attendee/AttendeeUpdateResponseMeta.gql'
import AttendeeUpdateResponseSlideMeta from 'src/graphql/attendee/AttendeeUpdateResponseSlideMeta.gql'
import AttendeeUpdateResponseNext from 'src/graphql/attendee/AttendeeUpdateResponseNext.gql'
import AttendeeUpdateResponseFinish from 'src/graphql/attendee/AttendeeUpdateResponseFinish.gql'
import { Session, SessionAttendee, Item, ItemTypeTopic } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar,
    ButtonClose,
    ButtonNext,
    SlidesViewer
  }
})
export default class AttendeeSessionSlidesViewer extends Vue {
  ItemTypeTopic = ItemTypeTopic
  me = store.state.person
  currSlideId = ''
  slides: Slide[] = []
  params: SlideParamsValues = {}

  @Prop()
  readonly topic!: Item

  @Prop()
  readonly session!: Session

  @Prop()
  readonly attendee!: SessionAttendee

  @Prop()
  readonly attendeeResponseResult!: AttendeeResponseResult

  @Prop()
  readonly isSessionOver!: boolean

  @Prop()
  readonly rightDrawerShowing!: boolean

  @Ref()
  readonly viewer!: SlidesViewer

  get startSlide () {
    return {
      id: 'start',
      type: 'Start',
      topic: this.topic,
      session: this.session
    }
  }

  get currSlide () {
    return this.slides.find(x => x.id === this.currSlideId)
  }

  get currSlideIndex () {
    return this.currSlide ? this.slides.indexOf(this.currSlide) + 1 : 0
  }

  get progress () {
    return this.currSlideIndex / Math.max(1, this.slides.length)
  }

  @Watch('topic.data.slides', { immediate: true, deep: true })
  async setSlides () {
    const attendeeItemData = new AttendeeItemData(this.topic.typeTopic as ItemTypeTopic, this.topic.data as ItemDataLive, this.attendee)
    this.slides = attendeeItemData.slides
    if (this.topic.typeTopic === ItemTypeTopic.Quiz) {
      const shuffle = attendeeItemData.meta
      const shufflePrev = this.attendee.data.shuffle || []
      if (!shuffle.every((v: string, i: number) => v === shufflePrev[i])) {
        await this.saveResponseMeta({ shuffle })
      }
      if (!this.slides.find((x: Json) => x.id === this.currSlideId)) {
        if (this.currSlideId) {
          await this.saveNextSlide(this.currSlideId)
        }
        this.currSlideId = this.slides.length ? this.slides[0].id : 'start'
        if (this.currSlideId) {
          await this.saveNextSlide(this.currSlideId)
        }
      }
    }
    const paramsMeta = attendeeItemData.params.getMeta(this.attendee.data as Response)
    this.params = attendeeItemData.params.getValues(paramsMeta)
    const paramsMetaPrev = this.attendee.data.params || {}
    if (!Object.keys(paramsMeta).every((k) => paramsMeta[k] === paramsMetaPrev[k])) {
      await this.saveResponseMeta({ params: paramsMeta })
    }
  }

  @Watch('session.data.showSlideId', { immediate: true })
  setSessionCurrSlideId (showSlideId: string) {
    if (this.topic.typeTopic === ItemTypeTopic.Keynote) {
      this.currSlideId = showSlideId || this.currSlideId || ''
    }
  }

  @Watch('attendee.data.currSlideId', { immediate: true })
  setAttendeeCurrSlideId (currSlideId: string) {
    if (this.topic.typeTopic === ItemTypeTopic.Quiz) {
      this.currSlideId = currSlideId || this.currSlideId || ''
    }
  }

  async created () {
    if (this.topic.typeTopic === ItemTypeTopic.Quiz && this.currSlideId) {
      await this.saveNextSlide(this.currSlideId)
    }
  }

  prev () {
    this.viewer.prev()
  }

  next () {
    this.viewer.next()
  }

  change (id: string) {
    if (this.topic.typeTopic === ItemTypeTopic.Quiz) {
      this.currSlideId = id
      this.$nextTick(async () => {
        await this.saveNextSlide(id)
      })
    }
  }

  async close () {
    if (this.topic.typeTopic === ItemTypeTopic.Quiz) {
      await this.saveNextSlide(this.currSlideId)
    }
    this.$emit('close')
  }

  async saveResponseMeta (meta: Json) {
    await api.mutate({
      query: AttendeeUpdateResponseMeta,
      variables: {
        attendeeId: this.attendee.id,
        meta
      }
    })
  }

  async saveSlideMeta (data: Json) {
    await api.mutate({
      query: AttendeeUpdateResponseSlideMeta,
      variables: {
        attendeeId: this.attendee.id,
        slideId: data.slide.id,
        meta: data.meta
      }
    })
  }

  async saveResponse (response: Json | undefined) {
    const { data: { updateAttendeeResponse } } = await api.mutate({
      query: AttendeeUpdateResponse,
      variables: {
        attendeeId: this.attendee.id,
        slideId: this.currSlideId,
        response: response === undefined ? null : response
      }
    })
  }

  async saveResponseWithStats (response: Json | undefined) {
    const { data: { updateAttendeeResponseAndSessionStats } } = await api.mutate({
      query: AttendeeUpdateResponseAndSessionStats,
      variables: {
        attendeeId: this.attendee.id,
        slideId: this.currSlideId,
        response: response === undefined ? null : response
      }
    })
  }

  async saveNextSlide (nextSlideId: string) {
    const { data: { updateAttendeeResponseNext } } = await api.mutate({
      query: AttendeeUpdateResponseNext,
      variables: {
        attendeeId: this.attendee.id,
        nextSlideId: nextSlideId || ''
      }
    })
  }

  async finishResponse () {
    const { data: { updateAttendeeResponseFinish } } = await api.mutate({
      query: AttendeeUpdateResponseFinish,
      variables: {
        attendeeId: this.attendee.id
      }
    })
  }
}
